import { eventThrottle } from '../utility';

export default class scrollTablist {
  constructor(el) {
    this.el = el;
    this.tablist = this.el.querySelector('[data-scroll-tablist]');
    this.previousArrow = this.el.querySelector('[data-scroll-tablist-control="previous"]');
    this.nextArrow = this.el.querySelector('[data-scroll-tablist-control="next"]');
    this.tabs = this.el.querySelectorAll('[data-scroll-tab]');
    this.init();
  }

  init() {
    this.handleArrowButtonVisibility();
    window.addEventListener('resize', eventThrottle(() => this.handleArrowButtonVisibility(), 50));
    this.tablist.addEventListener('scroll', eventThrottle(() => this.handleArrowButtonVisibility(), 50));
    this.previousArrow.addEventListener('click', () => this.scrollToPreviousTab());
    this.nextArrow.addEventListener('click', () => this.scrollToNextTab());
  }

  handleArrowButtonVisibility() {
    const hasHiddenTabs = this.tablist.scrollWidth > this.tablist.clientWidth;

    if (hasHiddenTabs && this.tablist.scrollLeft > 100) {
      this.previousArrow.classList.remove('hidden');
    } else {
      this.previousArrow.classList.add('hidden');
    }

    if (hasHiddenTabs && this.tablist.scrollLeft + this.tablist.clientWidth <= this.tablist.scrollWidth - 100) {
      this.nextArrow.classList.remove('hidden');
    } else {
      this.nextArrow.classList.add('hidden');
    }
  }

  scrollToNextTab() {
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].offsetLeft > this.tablist.scrollLeft) {
        this.tablist.scroll({
          top: 0,
          left: this.tabs[i].offsetLeft,
          behavior: 'smooth',
        });
        break;
      }
    }
  }

  scrollToPreviousTab() {
    for (let i = this.tabs.length - 1; i >= 0; i--) {
      if (this.tabs[i].offsetLeft < this.tablist.scrollLeft) {
        this.tablist.scroll({
          top: 0,
          left: this.tabs[i].offsetLeft,
          behavior: 'smooth',
        });
        break;
      }
    }
  }
}
